<div class="r-bg"></div>

<div class="r-left">
  <div class="flex flex-col">
    <img class="r-cybera" src="assets/logo/cybera_logo_dark.png" alt="Cybera" />
    <h4 class="r-prefix">For</h4>
    <img class="r-chainalysis" src="assets/logo/chainalysis.png" alt="Chainalysis" />
    <h4 class="r-subtitle">
      Chainalysis has partnered with CYBERA to give you access to powerful insights and help manage
      risk
    </h4>
    <p>
      Learn more about CYBERA at
      <a href="https://cybera.io" target="_blank"><strong>https://cybera.io</strong></a>
    </p>
  </div>
</div>

<div class="r-right">
  @if (!isEmailVerification && registerForm) {
    <div class="r-register-form card" [formGroup]="registerForm">
      <h3 class="m-0">Create your account</h3>
      <p class="text-center m-0">
        Register to gain free access to a trial account offering limited number of searches across
        our proprietary database
      </p>
      <input
        [formControlName]="controls.Firstname"
        class="r-control"
        placeholder="First name"
        [ngClass]="{
          'r-is-invalid': hasErrors(controls.Firstname),
        }" />
      <input
        [formControlName]="controls.Lastname"
        class="r-control"
        placeholder="Last name"
        [ngClass]="{
          'r-is-invalid': hasErrors(controls.Lastname),
        }" />
      <input
        [formControlName]="controls.Email"
        class="r-control"
        placeholder="Email"
        [ngClass]="{
          'r-is-invalid': hasErrors(controls.Email),
        }" />
      <div class="r-password-wrap">
        <input
          class="r-control"
          [formControlName]="controls.Password"
          [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="Password"
          [ngClass]="{
            'r-is-invalid': hasErrors(controls.Password) || passwordsAreDifferent,
          }" />
        <div class="r-password-info">
          <img src="images/complaint-design/info.png" class="" alt="info" />
          <div class="r-password-validation-list">
            <ul class="r-validation-result">
              <li
                class="r-password-validation-item"
                [ngClass]="{
                  'r-is-invalid-requirement':
                    hasRequirementError(passwordValidation.MinLength) ||
                    hasRequirementError(passwordValidation.Required),
                  'r-not-met-requirement': isPasswordPristine,
                }">
                <span>{{ minPasswordLength }} character minimum</span>
              </li>
              <li
                class="r-password-validation-item"
                [ngClass]="{
                  'r-is-invalid-requirement': hasRequirementError(passwordValidation.MaxLength),
                  'r-not-met-requirement': isPasswordPristine,
                }">
                <span>{{ maxPasswordLength }} character maximum</span>
              </li>
              <span>Only 3 out of 4 of the next requirements have to be met</span>
              @if (passwordValidation.Uppercase; as uppercase) {
                <li
                  class="r-password-validation-item"
                  [ngClass]="{
                    'r-is-invalid-requirement': hasRequirementError(uppercase),
                    'r-not-met-requirement': hasNotMetRequirement(uppercase) || isPasswordPristine,
                  }">
                  <span>One uppercase character</span>
                </li>
              }
              @if (passwordValidation.Lowercase; as lowercase) {
                <li
                  class="r-password-validation-item"
                  [ngClass]="{
                    'r-is-invalid-requirement': hasRequirementError(lowercase),
                    'r-not-met-requirement': hasNotMetRequirement(lowercase) || isPasswordPristine,
                  }">
                  <span>One lowercase character</span>
                </li>
              }
              @if (passwordValidation.NonAlphas; as nonAlphas) {
                <li
                  class="r-password-validation-item"
                  [ngClass]="{
                    'r-is-invalid-requirement': hasRequirementError(nonAlphas),
                    'r-not-met-requirement': hasNotMetRequirement(nonAlphas) || isPasswordPristine,
                  }">
                  <span>One special character</span>
                </li>
              }
              @if (passwordValidation.Numbers; as numbers) {
                <li
                  class="r-password-validation-item"
                  [ngClass]="{
                    'r-is-invalid-requirement': hasRequirementError(numbers),
                    'r-not-met-requirement': hasNotMetRequirement(numbers) || isPasswordPristine,
                  }">
                  <span>One number</span>
                </li>
              }
              <li
                class="r-password-validation-item"
                [ngClass]="{
                  'r-is-invalid-requirement':
                    passwordsAreDifferent && (!isPasswordPristine || !isPassword2Pristine),
                  'r-not-met-requirement': isPasswordPristine && isPassword2Pristine,
                }">
                <span>Confirm your password</span>
              </li>
            </ul>
          </div>
        </div>
        <img
          (click)="isPasswordVisible = !isPasswordVisible"
          src="assets/eye{{ !isPasswordVisible ? '-slash' : '' }}.svg"
          alt="hide password" />
      </div>
      <div class="r-password-wrap">
        <input
          class="r-control"
          [formControlName]="controls.ConfirmPassword"
          [type]="isPassword2Visible ? 'text' : 'password'"
          placeholder="Confirm password"
          [ngClass]="{
            'r-is-invalid': hasErrors(controls.ConfirmPassword) || passwordsAreDifferent,
          }" />
        <img
          (click)="isPassword2Visible = !isPassword2Visible"
          src="assets/eye{{ !isPassword2Visible ? '-slash' : '' }}.svg"
          alt="hide password" />
      </div>
      <div class="text-center">
        By signing up for a demo, you agree to allow us to reach out. Your data will be handled in
        accordance with our
        <a href="https://cybera.io/privacy-policy/" target="_blank">privacy policy.</a>
      </div>
      <button (click)="register()" [disabled]="isDisabled">
        @if (isLoading) {
          <ops-loading />
        }
        <span [ngClass]="{ invisible: isLoading }">Register</span>
      </button>
      <div class="flex gap-1">
        <p class="mb-0 mt-0">Already have an account?</p>
        <a (click)="msal.loginRedirect()">Log in now</a>
      </div>
    </div>
  }
</div>
